import CandidatesIcon from 'assets/images/iPrise/Candidates.svg';
import JobQueueIcon from 'assets/images/iPrise/JobQueue.svg';
import ReportsIcon from 'assets/images/iPrise/Reports.svg';
import TeamIcon from 'assets/images/iPrise/Team.svg';
import CommonHeader, { NavItem } from 'pages/iPriseV2/common/layout/Header';
import React from 'react';

const BusinessHeadHeader: React.FC = () => {
  const navItems: NavItem[] = [
    {
      icon: JobQueueIcon,
      label: 'Job Queue',
      path: '/business-head/job-queue',
    },
    {
      icon: CandidatesIcon,
      label: 'Candidates',
      path: '/business-head/candidates',
    },
    { icon: TeamIcon, label: 'My Team', path: '/business-head/teams' },
    { icon: ReportsIcon, label: 'Reports', path: '/business-head/reports' },
  ];

  return (
    <CommonHeader
      navItems={navItems}
      profilePath="/business-head/profile"
      basePath="/business-head"
    />
  );
};

export default BusinessHeadHeader;
